export default __webpack_public_path__ + "static/media/group1.8a6d28a1.png";